export default __webpack_public_path__ + "static/media/tinder_buttons.64bd62df.svg";